var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "width",
    height: "height",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9CBDEF",
    fillRule: "evenodd",
    stroke: "#EC008C",
    d: "M8.607 2.577a.43.43 0 0 0-.429.429v2.786c0 1.183-.96 2.143-2.143 2.143H3.463a.43.43 0 0 0-.428.428v2.358c0 .236.192.428.428.428h3.643l1.5 1.715H3.464A2.143 2.143 0 0 1 1.32 10.72V8.363c0-1.183.96-2.143 2.143-2.143h2.572a.43.43 0 0 0 .429-.428V3.006c0-1.184.959-2.143 2.143-2.143h2.357c1.184 0 2.143.96 2.143 2.143v3.643h-1.714V3.006a.43.43 0 0 0-.43-.429z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9CBDEF",
    fillRule: "evenodd",
    stroke: "#EC008C",
    d: "M11.393 17.15a.43.43 0 0 0 .429-.429v-2.786c0-1.183.959-2.143 2.142-2.143h2.572a.43.43 0 0 0 .429-.429V9.006a.43.43 0 0 0-.43-.429h-3.642l-1.5-1.714h5.143c1.183 0 2.143.96 2.143 2.143v2.357c0 1.184-.96 2.143-2.143 2.143h-2.571a.43.43 0 0 0-.429.43v2.785c0 1.184-.959 2.143-2.143 2.143H9.036a2.143 2.143 0 0 1-2.143-2.142v-3.644h1.714v3.643c0 .237.192.43.429.429z",
    clipRule: "evenodd"
  })));
};
export default SvgPlus;